var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from '@utex/base-api-sdk';
var AccessRecoveryService = (function (_super) {
    __extends(AccessRecoveryService, _super);
    function AccessRecoveryService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clientName = 'AccessRecoveryService';
        _this.recoveryStart = _this.createRest('/rest/grpc/com.unitedtraders.luna.mobilegateway.recovery.AccessRecoveryService.recoveryStart', false, 'schema.json#/properties/accessRecoveryStartRequest', 'schema.json#/properties/accessRecoveryStartResponse', 'AccessRecoveryService/recoveryStart');
        _this.recoveryActivate = _this.createRest('/rest/grpc/com.unitedtraders.luna.mobilegateway.recovery.AccessRecoveryService.recoveryActivate', false, 'schema.json#/properties/accessRecoveryActivateRequest', 'schema.json#/properties/accessRecoveryActivateResponse', 'AccessRecoveryService/recoveryActivate');
        _this.recoveryFinish = _this.createRest('/rest/grpc/com.unitedtraders.luna.mobilegateway.recovery.AccessRecoveryService.recoveryFinish', false, 'schema.json#/properties/accessRecoveryFinishRequest', 'schema.json#/properties/accessRecoveryFinishResponse', 'AccessRecoveryService/recoveryFinish');
        return _this;
    }
    return AccessRecoveryService;
}(BaseService));
export { AccessRecoveryService };
//# sourceMappingURL=AccessRecoveryService.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/utcom-api-sdk/es/com/unitedtraders/luna/mobilegateway/recovery/AccessRecoveryService.js
// module id = 749
// module chunks = 118